<template>
  <div class="like-info-container">
    <div class="no-userLikes" v-if="userLikes.length===0">
      <span>{{ $t('shared.userLikes.noLikes') }}</span>
    </div>
    <div v-else>
      <div class="filter-likes">
        <button class="filter-like-type"
                :class="{selected: !selectedType}"
                @click="() => selectType(undefined)"
        >
          All
        </button>
        <button class="filter-like-type"
                :class="{selected:selectedType===config.type}"
                v-for="config in likeConfig" :key="config.type"
                @click="() => selectType(config.type)"
        >
          {{ config.icon }}&nbsp;{{ config.count }}
        </button>
      </div>
      <virtual-list class="likers-container"
                    :keeps="10"
                    :estimate-size="44"
                    :data-key="'id'"
                    :data-sources="filteredLikes"
                    :data-component="itemComponent"
      />
    </div>
  </div>
</template>

<script>
import VirtualList from 'vue-virtual-scroll-list'
import UserLikesVirtualItem from './UserLikesVirtualItem'
import LikeService from '../../service/like.service'

export default {
  name: 'UserLikes',
  components: { VirtualList },
  props: {
    userLikes: {
      // { id, firstName, lastName, idImage, 'likes.type'}
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      itemComponent: UserLikesVirtualItem,
      selectedType: undefined,
      userLikeAttribute: 'likes.type'
    }
  },
  computed: {
    likeConfig() {
      const countByType = this.userLikes.reduce((map, userLike) => {
        const type = userLike[this.userLikeAttribute]
        map[type] = (map[type] || 0) + 1
        return map
      }, {})
      return LikeService.getLikesConfig().map(config => {
        config.count = countByType[config.type]
        return config
      }).filter(config => config.count > 0)
    },
    filteredLikes() {
      if (this.selectedType) {
        return this.userLikes.filter(like => like[this.userLikeAttribute] === this.selectedType)
      } else {
        return this.userLikes
      }
    }
  },
  methods: {
    selectType(type) {
      this.selectedType = type
    }
  }
}
</script>

<style scoped lang="scss">
.like-info-container {

  .no-userLikes {
    color: $black-color;
    font-weight: 600;
    font-size: 16px;
    height: 46px;
    display: flex;
    align-items: center;
    margin-left: 28px;
  }

  .likers-container {
    // :keeps="10" must be more than visible items
    // :estimate-size="44" estimated size in px of each item
    // max visible item set to 7
    max-height: 44*5px;
    overflow-y: auto;
  }
}

.filter-likes {
  display: flex;
  padding: 0 0.5em;
  border-bottom: 1px solid color.adjust(white, $lightness: -10%);
  margin-bottom: 0.5em;

  .filter-like-type {
    padding: 0.5em 1em;
    background: none;
    cursor: pointer;
    border: none;
    color: $black-color;
    display: flex;
    align-items: center;
    font-size: 14px;

    &:hover {
      background-color: color.adjust(white, $lightness: -10%);
    }

    &.selected {
      padding-bottom: calc(0.5em - 3px);
      border-bottom: 3px solid $secondary-color;
    }
  }
}

/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #CCE5E9;
  border-radius: 100px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgb(255, 255, 255);
  border-radius: 100px;
  border: 2px solid #CCE5E9;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgb(243, 252, 255);
}
</style>
